<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-10 col-lg-8 col-xl-6 mx-auto pt-3">

        <div v-if="changeMode">
          <h1 class="text-center pb-3">Change Password</h1>
          <change-password-form @changeSuccess="toggleMode" :csrfToken="csrfToken"></change-password-form>
        </div>

        <div v-else class="text-center">
          <h2>Password was changed successfully</h2>
          <button @click="toggleMode" class="btn btn-sm btn-success" type="button">Back</button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import ChangePasswordForm from '../../components/forms/ChangePasswordForm'

export default {
  components: {
    changePasswordForm: ChangePasswordForm,
  },
  data() {
    return {
      changeMode: true,
    }
  },
  methods: {
    toggleMode() {
      this.changeMode = !this.changeMode
    },
  },
  computed: {
    csrfToken: function() {
      return this.$store.getters.getToken
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/auth/ChangePassPage.vue